import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { Button, TextField, InputAdornment } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { css } from '@emotion/core';
import { toJS } from 'mobx';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { StyledForm } from '../../styles/styles';
import { MenuList, filterOptions } from '../../util/ReactSelectOverrides';
import { safeEval } from '../../util/UtilFunctions';
import RenderPropModal from '../../dealMapper/common/RenderPropModal';
import MappedVouchersDisplay from './MappedVouchersDisplay';
import { CustomSelect } from '../../util/CustomCreatableSelect';
import { useSnackBars } from '../../../alerts/SnackBarProvider';
import { COLORS } from '../../util/Colors';

const customStyles = {
  control: base => ({
    ...base,
    height: 49,
    minHeight: 49,
    paddingLeft: '3px',
  }),
  menu: provided => ({
    ...provided,
    zIndex: 9999,
  }),
};

const ApplyToVoucher = ({
  payment,
  paymentVouchers,
  fetchPaymentVouchers,
  changePaymentVouchers,
}) => {
  const history = useHistory();
  const { authStore, dataStore } = useRootStore();
  const { PaymentId, Amount } = payment;
  const vouchers = dataStore.voucherArray;

  const initialValues = {
    voucher: null,
    voucherId: null,
    amount: Amount,
  };

  const removePaymentVoucher = pvToRemove => {
    changePaymentVouchers(
      paymentVouchers.filter(pv => pv.VoucherId !== pvToRemove.VoucherId),
    );
  };

  const vtype = v => {
    toJS(v);
    if (
      v.VoucherTypeId === 2 ||
      v.VoucherTypeId === 4 ||
      v.VoucherTypeId === 6
    ) {
      return 'AP';
    }

    if (
      v.VoucherTypeId === 1 ||
      v.VoucherTypeId === 3 ||
      v.VoucherTypeId === 5
    ) {
      return 'AR';
    }

    throw new Error('No voucher type');
  };

  const availableVouchersToSelect = () => {
    const vouchersWithoutSelected = vouchers.filter(voucher =>
      paymentVouchers.every(pi => pi.VoucherId !== voucher.VoucherId),
    );

    // const selectedType = paymentVouchers.
    if (paymentVouchers.length > 0) {
      const aMappedVoucher = vouchers.find(
        v => v.VoucherId === paymentVouchers[0].VoucherId,
      );
      const currentPaymentVoucherType = vtype(aMappedVoucher);
      const filteredVoucherArray = vouchersWithoutSelected.filter(
        voucher => vtype(voucher) === currentPaymentVoucherType,
      );
      return filteredVoucherArray;
    }

    return vouchersWithoutSelected;
  };

  return (
    <Observer
      render={() => {
        return (
          <RenderPropModal
            containerStyle={{ width: '100%', marginTop: '1rem' }}
            cardDisplay={({ handleClose }) => (
              <Formik
                initialValues={initialValues}
                onSubmit={async (values, actions) => {
                  // TODO: check capitilization
                  changePaymentVouchers([
                    ...paymentVouchers,
                    {
                      VoucherId: values.voucherId,
                      PaymentId,
                      Amount: values.amount,
                    },
                  ]);
                  handleClose();
                }}
                render={({
                  handleBlur,
                  handleChange,
                  setFieldValue,
                  errors,
                  handleSubmit,
                  values,
                  isSubmitting,
                  resetForm,
                }) => {
                  return (
                    <StyledForm style={{ width: '300px' }}>
                      <div style={{ width: '100%', zIndex: 1000 }}>
                        <CustomSelect
                          isSearchable
                          isClearable
                          placeholder="Vouchers"
                          components={{ MenuList }}
                          options={availableVouchersToSelect()}
                          // getOptionLabel={option => option.VoucherNumber}
                          getOptionLabel={({
                            VoucherNumber,
                            VoucherDate,
                            ContactName,
                            Amount: vAmount,
                          }) => (
                            <div style={{ height: '38px', overflow: 'hidden' }}>
                              <div>{ContactName}</div>
                              <div>
                                {VoucherDate} - $
                                {parseFloat(vAmount).toFixed(2)}
                              </div>
                            </div>
                          )}
                          getOptionValue={option => option.VoucherId}
                          value={values.voucher}
                          styles={customStyles}
                          filterOption={filterOptions}
                          onChange={val => {
                            setFieldValue('voucher', val);
                            setFieldValue(
                              'voucherId',
                              safeEval(() => val.VoucherId),
                              null,
                            );
                          }}
                        />
                      </div>

                      <TextField
                        name="amount"
                        label="Amount"
                        value={values.Amount}
                        max={Amount}
                        margin="normal"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="outlined"
                        fullWidth
                        error={errors.amount}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                      />
                      <div
                        css={css`
                          display: flex;
                          margin-top: 1.2rem;
                          justify-content: center;
                          & > button,
                          a {
                            margin: 5px;
                          }
                        `}
                      >
                        <Button
                          color="primary"
                          variant="contained"
                          type="submit"
                          size="large"
                          disabled={isSubmitting || !values.voucher}
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                        <Button
                          color="secondary"
                          variant="outlined"
                          size="large"
                          onClick={() => {
                            resetForm(initialValues);
                            handleClose();
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </StyledForm>
                  );
                }}
              />
            )}
          >
            {({ handleOpen }) => (
              <MappedVouchersDisplay
                paymentVouchers={paymentVouchers}
                fetchPaymentVouchers={fetchPaymentVouchers}
                addVoucher={handleOpen}
                removeVoucher={removePaymentVoucher}
              />
            )}
          </RenderPropModal>
        );
      }}
    />
  );
};

export default ApplyToVoucher;
